// import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import '../styles/App.css';
import '../styles/CardProject.css';

export default class CardProject extends Component {

  render() {
    const { projects } = this.props;
    const { title, description, img, reposotorio, deploy, tecnologies } = projects;
    return (
      <section className="container-card-project">
        {/* <Link className="link" to={`${title}`}> */}
          <img src={img} alt={`Imagem do projeto ${title}`} />
          <div>
            <h5 className="title-project">{title}</h5>
            
            <p className="description-project">{description}</p>
            
          </div>
        {/* </Link> */}
       
        <div className="container-tec">
          { tecnologies.map((tec, index) => (
            <div  key={index}>
              <p>{tec}</p>
            </div>
          ))}
        </div>
        <div className="container-btn">
          <a className="btn-repo" href={reposotorio} rel="noreferrer" target="_blank">Repositorio</a>
          <a className="btn-deploy" href={deploy} target="_blank" rel="noreferrer">Deploy</a>
        </div>
      </section>
    )
  };
};

/*{
    title: '',
    img: '',
    description: '',
    tecnologies: [],
    reposotorio: '',
    deploy: '',
},*/